import { Component, computed, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { FormFieldService } from '../../../services/form-field/form-field.service';
import {
  DatePickerFormFieldOptions,
  FormFieldLabels,
} from '../../../form-field.types';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-date-picker-form-field',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  templateUrl: './date-picker-form-field.component.html',
  styleUrl: './date-picker-form-field.component.scss',
})
export class DatePickerFormFieldComponent {
  private formFieldService = inject(FormFieldService);

  name = input('');
  path = input<string>();
  labels = input<FormFieldLabels>();
  options = input<DatePickerFormFieldOptions>();
  errorStateMatcher = input<ErrorStateMatcher>({
    isErrorState: control => !!(control?.touched && control?.errors),
  });

  formGroup = this.formFieldService.formGroup;
  control = computed(() => {
    const path = this.path() ?? this.name();
    const formGroup = this.formGroup();
    return formGroup?.get(path) as FormControl;
  });

  required = computed(() => !!this.options()?.required);
  label = computed(() => this.labels()?.label);
  placeholder = computed(() => this.labels()?.placeholder ?? '');
  selectMode = computed(() => this.options()?.selectMode ?? 'single');
  help = computed(() => this.labels()?.help);
  error = this.formFieldService.controlErrorMessage(this.name, this.path);
  min = computed(() => this.options()?.min);
  max = computed(() => this.options()?.max);
  startAt = computed(() => {
    const customStartAt = this.options()?.startAt;
    if (customStartAt) {
      return customStartAt;
    }
    const startAt = new Date();
    startAt.setHours(0, 0, 0, 0);
    return startAt;
  });
}
